import * as actionTypes from 'domains/campaigns/state/actionTypes';
import { getCurationNavState } from 'domains/campaigns/state/utils';
import { AudienceState } from 'domains/campaigns/types';
import { CurationNavState, URLPaths } from 'models/enums';
import { Action } from 'models/types';
import { ROUTE_CHANGE } from 'state/constants';

export const initialState: AudienceState = {
    navState: CurationNavState.PREVIEW,
    isComplete: false,
    audienceId: null,
};

export const isFormComplete = (state: AudienceState) => Boolean(state.audienceId);

export const audienceReducer = (state = initialState, action: Action) => {
    switch (action.type) {
        case actionTypes.CONDITIONAL_SPLIT_EDIT_AUDIENCE:
            const stateAfterEdit = {
                ...state,
                audienceId: action.payload.audienceId,
            };
            return {
                ...stateAfterEdit,
                navState: getCurationNavState(
                    isFormComplete(stateAfterEdit),
                    false,
                    URLPaths.CURATIONS_CONDITIONAL_SPLIT_SEGMENT,
                    undefined,
                    URLPaths.CURATIONS_CONDITIONAL_SPLIT
                ),
                isComplete: isFormComplete(stateAfterEdit),
            };
        case ROUTE_CHANGE:
            return {
                ...state,
                navState: getCurationNavState(
                    isFormComplete(state),
                    false,
                    URLPaths.CURATIONS_CONDITIONAL_SPLIT_SEGMENT,
                    action,
                    URLPaths.CURATIONS_CONDITIONAL_SPLIT
                ),
            };
        case actionTypes.CONDITIONAL_SPLIT_RESET_CURATION:
            return initialState;
        default:
            return state;
    }
};

export default audienceReducer;
